<!--代收款-->
<template>
  <div class="OrderCollectionOnDehalf">
        <el-dialog 
            :visible.sync="collectionShow" 
            width="1000px"
            :z-index="9"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            center 
        >
            <div class="onDehalf-title">
                <div>代收款</div>
                <!--关闭-->
                <span class="close" @click="$emit('onShow')"><i class="el-icon-close"></i></span>
            </div>
            <!--未设置代收款提示-->
            <div v-if="!broker" class="noHint">
                <img src="/images/prompt/icon_5.png" class="img">
                <p>暂无代收款信息</p>
                <el-button @click="modifyOrder" type="primary" class="bottom"  style="width: 40%; margin-top: 20px;">去设置</el-button>
                <p>提示:设置代收款后会已代收款价格支付订单</p>
            </div>
            <template v-else>
                <div class="hint">提示：该页面只显示代收款价格对比、实际页面为支付二维码小程序页面</div>
                <OrderHousing :onDehalf="1" :orderDetail="paymentDetail" :quotationList="quotationList"></OrderHousing>
                <!--操作按钮-->
                <div  class="onDehalf-bottoms">
                    <!--订单总额-->
                    <div class="price">
                        <div>订单总额：<span>¥{{ paymentDetail.price_orig }}</span><p>¥{{ paymentDetail.price }}</p></div>
                    </div>
                    <el-button type="success" class="bottom" size="small" icon="el-icon-edit">修改代收款</el-button>
                    <el-button @click="message=true"  type="warning" class="bottom" size="small" icon="el-icon-message">短信通知</el-button>
                    <el-button :loading="loading" @click="handleGetQRCode" type="primary" class="bottom" size="small" icon="el-icon-full-screen">支付二维码</el-button>
                    <el-button  @click="$emit('onShow')" class="bottom" size="small" icon="el-icon-right">返回</el-button>
                </div>
            </template>
        </el-dialog>
        <!--代收款短信通知-->
        <el-dialog  :visible.sync="message" width="360px"  center  :z-index="11" top="32vh" :close-on-click-modal="false">
            <div class="onDehalf-title">
                <div>代收款短信通知</div>
            </div>
            <el-form label-position="right" :model="formLabelAlign" :rules="rules" ref="formLabelAlign" @submit.native.prevent>
                <el-form-item label="代收款人手机号" prop="mobile">
                <el-input v-model.number="formLabelAlign.mobile" type="number" ></el-input>
                </el-form-item>
                <el-form-item class="formbuttton">
                    <div  class="onDehalf-bottoms">
                        <el-button @click="message=false;formLabelAlign.mobile='';">取消</el-button>
                        <el-button type="primary" @click="submitForm('formLabelAlign')">发送通知</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--支付二维码-->
        <el-dialog  :visible.sync="payQrcodeShow" width="360px"  center  :z-index="11" top="32vh" >
            <div class="onDehalf-title">
                <div>支付二维码</div>
                <img :src="payQrcodeImg" width="200px" height="200px" class="base64Img">
                <p class="hotel-title">{{ paymentDetail.hotel_title }}</p>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { mapState,mapActions} from 'vuex'
import OrderHousing from './OrderHousing'
export default {
  name: 'OrderCollectionOnDehalf',
  components: {
    OrderHousing
  },
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    quotationList: {
      type: Object,
      default: () => {}
    },
    collectionShow:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
        paymentDetail:{
            room_need_arr:[],
            meeting_need_arr:[],
        },
        message:false,
        formLabelAlign: {
          oid: '',
          mobile: '',
        },
        rules:{
          mobile: [
            { validator: this.$verify.phoneNumber, trigger: 'blur' },
          ]
        },
        //支付二维码开关
        payQrcodeShow:false,
        //支付二维码图片
        payQrcodeImg:'',
        loading:false,
    };
  },
  computed: {
    //是否已设置代收款
    broker(){
      return this.orderDetail.broker>0
    }
  },
  watch: {
    collectionShow(newVal,oldVal){
      if(newVal&&this.broker&&!this.paymentDetail.oid){
        this.BrokerOrderHotelDetail();
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['deleteShare','deleteNotice','weChatQrCode']),
    //获取代收款详情
    BrokerOrderHotelDetail(){
        let orderDetail=this.orderDetail;
        this.deleteShare({
            data:{oid:Number(orderDetail.oid)},
            successFun:(res)=>{
                res.info.price_orig=orderDetail.price;
                res.info.hotel_breakfast_type=orderDetail.hotel_breakfast_type;
                this.paymentDetail=res.info;
            }
        })
    },
    //代收款短信通知
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
            this.deleteNotice({
                data:{
                    ...this.formLabelAlign,
                    oid:this.paymentDetail.oid
                },
                successFun: (res) => {
                    this.message=false;
                    this._alert('通知发送成功');
                }
            });
            } else {
            return false;
            }
        });
    },
    //获取支付二维码
     async handleGetQRCode(){
        //已获取过不重新调用
        if(this.payQrcodeImg){
            this.payQrcodeShow=true;
            return;
        }
        //获取支付二维码
        this.loading=true;
        let res =  await this.weChatQrCode({data:{oid:this.paymentDetail.oid}});
        if(res){
            this.payQrcodeImg='data:image/jpeg;base64,'+res.qr_code;
            this.payQrcodeShow=true;
            this.loading=false;
        }
    },
    //修改代收款订单
    modifyOrder() {
        let query = {type:this.orderDetail.order_type,orderId:this.orderDetail.oid,modify:true,behalf:1}
        this.$router.push({name:'OrderPost',query})
    },
    orderComplete(){
        
    },
  }
};
</script>

<style lang="scss" scoped>
    .onDehalf-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        text-align: center;
        position: relative;
    }
    .noHint{
        text-align: center;
        margin-top: 20px;
        .img{
            width: 200px;
        }
        p{
            margin-top: 14px;
            color:#999
        }
    }
    .hint{
        width: 93%;
        background-color: var(--smtc-color-warning);
        color: #fff;
        margin: 0 auto;
        padding: 4px 2%;
        border-radius: 15px;
        font-size: 12px;
    }
    .onDehalf-bottoms{
        display: flex;
        justify-content:flex-end;
    }
    .base64Img{
        margin-top: 20px;
    }
    .hotel-title{
        font-size: 14px;
        font-weight: bold;
        margin-top: 10px;
    }
    .price{
        margin-right:auto;
        margin-left: 3%;
        line-height: 30px;
        color: var(--smtc-color-text-black);
        font-weight: bold;
        span{
            color: var(--smtc-color-text-shallow);
            text-decoration: line-through;
            margin-right: 6px;
            font-weight: normal;
            font-size: 12px;
        }
        p{
            display: inline-block;
            color: red;
        }
    }
    .close{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #999;
        background-color: #f3f4f8;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;
    }
</style>
<style >
    .OrderCollectionOnDehalf .el-dialog__headerbtn{
        background-color: #f3f4f8;
        border-radius: 50px;
        width: 24px;
        height: 24px;
        font-size: 14px;
    }
    .OrderCollectionOnDehalf .el-dialog__headerbtn .el-dialog__close{
        color:#999;
    }
</style>